import React, { useState, useEffect, useCallback, useContext } from 'react';

import { ReactComponent as EnterDueDate } from '../../../../assets/novosicones/Renegociacao/today_black_24dp.svg';

import DropDown from '../../../Reutilizaveis/DropDown';

import { Item, ItemContent } from './styles.js';
import createDateWithoutTimezone from '../../../../Utils/createDateWithoutTimezone';
import { ContextoFinanceiro } from '../../../../services/financeiro.js';

const VencimentoEntrada = ({ estilo, tema, setRegras, regras }) => {
  const [vencimentoEntrada, setVencimentoEntrada] = useState('');

  const { holidays, getHolidays, checkIsHoliday } =
    useContext(ContextoFinanceiro);

  const SATURDAY = 0;
  const SUNDAY = 6;

  const getAllDaysInMonth = useCallback(() => {
    let today = new Date();

    let actualMonth = today.getMonth();

    let date = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    let dates = [];

    let daysCount = 1;

    while (date.getMonth() === actualMonth && daysCount <= 10) {
      const month = date.getMonth() + 1;

      // if (
      //   daysCount === 10 &&
      //   (date.getDay() == SATURDAY ||
      //     date.getDay() == SUNDAY ||
      //     checkIsHoliday(date))
      // ) {
      while (
        date.getDay() == SATURDAY ||
        date.getDay() == SUNDAY ||
        checkIsHoliday(date)
      ) {
        date.setDate(date.getDate() + 1);
      }
      // }

      dates.push({
        date: createDateWithoutTimezone(date)?.toISOString()?.split('T')[0],
        id: date.getDate(),
        nome: `${date.getDate().toString().padStart(2, 0)}/${month
          .toString()
          .padStart(2, 0)}/${date.getFullYear()}`,
      });

      date.setDate(date.getDate() + 1);

      daysCount++;
    }

    return dates;
  }, [holidays]);

  useEffect(() => {
    let selected = getAllDaysInMonth().filter(
      (date) => date.nome === vencimentoEntrada
    );
    setRegras({ ...regras, vencimentoEntrada: selected[0] });
  }, [vencimentoEntrada]);

  useEffect(() => {
    const callGetHolidays = async () => {
      await getHolidays();
    };

    callGetHolidays();

    const days = getAllDaysInMonth();

    if (days.length === 1) {
      setVencimentoEntrada(days.nome);
    }
  }, []);

  return (
    <Item>
      <span>
        <b>Vencimento da entrada:</b>
      </span>
      <ItemContent>
        <EnterDueDate
          className='iconeRenegociacao'
          style={
            vencimentoEntrada
              ? { fill: tema.primaryColor }
              : { fill: '#4d4d4d' }
          }
        />
        <DropDown
          itens={getAllDaysInMonth()}
          idDropDown={'ListaVencimentoEntrada'}
          setValue={setVencimentoEntrada}
          nomeDropDown='Selecione a melhor data'
          style={{ margin: 0, border: 0 }}
          renegociacao
          renegociacaoWidth={estilo}
        />
      </ItemContent>
      <span>
        <b>Até 10 dias úteis</b> no mês vigente.
      </span>
    </Item>
  );
};

export default VencimentoEntrada;
